import classNames from "classnames";
import styles from "./Panel.module.scss";
import React, { forwardRef } from "react";

type PanelProps = {
    theme?: "dark" | "green" | "light" | "orange";
} & React.HTMLAttributes<HTMLDivElement>;

const Panel = forwardRef((props: PanelProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return <div
        {...props}
        className={classNames(styles[props.theme || "light"], props.className)}
        ref={ref}
    >
        {props.children}
    </div>
});

export { Panel };
